import React, { createContext, useContext } from "react";

/**
 * Scopes that count in the staff application (the shell with the sidebar).
 * ANY is school-wide access and OWN is a staff member's own work, such as a teacher's own classrooms.
 * RELATED only describes a parent's relation to their own family and children, so it belongs to the
 * parent portal and must never reveal staff navigation, pages or actions.
 */
export const STAFF_SCOPES = Object.freeze(["ANY", "OWN"]);

const PermissionScopeContext = createContext(null);

/** Limits every useCan/RequireCan/RequireAnyCan check below it to the given grant scopes. */
export function PermissionScopeProvider({ scopes, children }) {
  return (
    <PermissionScopeContext.Provider value={scopes}>
      {children}
    </PermissionScopeContext.Provider>
  );
}

/** The scopes that count here, or null when every granted scope counts (outside the staff shell). */
export function usePermissionScopes() {
  return useContext(PermissionScopeContext);
}
